import React from 'react';
import PageSizeSelect from './PageSizeSelect';
import CurrentItemPosition from './CurrentItemPosition';
import PageNavigator from './PageNavigator';

const lineup = {
    width: 300,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 5
};

const Pagination = ({
    pageInfo,
    onPageSizeChange,
    invert,
    onPrevClick,
    onNextClick
}) => {
    return (
        <div style={lineup}>
            <PageSizeSelect
                invert={invert}
                pageInfo={pageInfo}
                onPageSizeChange={onPageSizeChange}
            />
            <CurrentItemPosition
                totalItemCount={pageInfo.totalItemCount}
                pageSize={pageInfo.pageSize}
                pageNumber={pageInfo.pageNumber}
            />
            <PageNavigator
                hasPreviousPage={pageInfo.hasPreviousPage}
                hasNextPage={pageInfo.hasNextPage}
                isFirstPage={pageInfo.isFirstPage}
                isLastPage={pageInfo.isLastPage}
                onPrevClick={onPrevClick}
                onNextClick={onNextClick}
            />
        </div>
    );
};

export default Pagination;
